<template>

    <div>
        <div class="login">

            <div class="login__left">

                <div :class="{'login__header__between': !isTuto && isDesktop}" class="login__header">

                    <img class="login__header__img" src="/img/logo/large/blue.svg" @click="goLanding">

                    <span v-if="isIntro && isDesktop"
                          class="login__header__text">{{ $t('web_login_google_welcome_reconnect_1') }} <a
                        class="login__header__btn"
                        @click="TagClick('reconnect');goStep('login')">{{
                            $t('web_login_google_welcome_reconnect_2')
                        }}</a></span>
                    <span v-if="isLogin && isDesktop"
                          class="login__header__text">{{ $t('web_login_google_connect_header_lost_1') }} <a
                        class="login__header__btn"
                        @click="TagClick('see_steps');goStep('intro')">{{
                            $t('web_login_google_connect_header_lost_2')
                        }}</a></span>

                </div>

                <div v-if="!isLogin" :class="{'login__steps__container-intro': isIntro}"
                     class="login__steps__container">

                    <div v-if="isIntro" class="login__steps__bloc">

                        <h1 class="login__title">{{ $t('web_login_google_welcome_title') }}</h1>

                        <p class="login__text mt__8">{{ $t('web_login_google_welcome_subtitle_app_password') }}</p>

                        <div class="login__steps__btn mt__16">
                            <span class="login__steps__number">1</span>
                            <span class="login__text-btn">{{ $t('web_login_google_welcome_step_1') }}</span>
                        </div>

                        <p class="login__text mt__32">{{ $t('web_login_google_welcome_subtitle_imap_2FA') }}</p>

                        <div class="login__steps__btn login__steps__btn-dashed mt__16">
                            <span class="login__steps__number login__steps__number-dashed">2</span>
                            <span class="login__text-btn login__text-btn-dashed">{{
                                    $t('web_login_google_welcome_step_2')
                                }}</span>
                        </div>

                        <div class="login__steps__btn login__steps__btn-dashed mt__8">
                            <span class="login__steps__number login__steps__number-dashed">3</span>
                            <span class="login__text-btn login__text-btn-dashed">{{
                                    $t('web_login_google_welcome_step_3')
                                }}</span>
                        </div>

                        <div v-if="isDesktop" class="mt__24">

                            <button class="login__footer__btn" @click="TagClick('start');nextStep()">
                                {{ $t('web_login_google_welcome_CTA_start') }}
                            </button>

                            <div class="login__footer__row mt__8">

                                <img class="login__footer__ico" src="/img/icons/clock-grey.svg">

                                <p class="login__footer__text">{{ $t('web_login_google_welcome_timing') }}</p>

                            </div>

                        </div>

                    </div>

                    <div v-if="isTuto" class="login__tuto">

                        <img :src="actualStep.img" class="login__steps__img">

                        <h2 class="login__subtitle mt__32">{{ $t(actualStep.title) }}</h2>

                        <p class="login__text mt__8 mb-24">{{ $t(actualStep.subtitle) }}</p>

                        <div v-for="(step, stepIndex) in actualStep.steps"
                             :class="{'login__steps__btn-active': step.active}"
                             class="login__steps__btn mt__8"
                             @mouseover="mouseOver(step, stepIndex +1)">
                            <span class="login__steps__number">{{ stepIndex + 1 }}</span>
                            <span class="login__text-btn">{{ getStepText(step.text) }}</span>
                        </div>

                    </div>

                    <button
                        v-if="isTuto"
                        :class="{'login__steps__btn-provider-clicked': linkClicked}"
                        class="btn btn-blue login__steps__btn-provider mt__24 blue-desktop-hover"
                        @click="TagClick('continue');openProviderSettings()"
                    >{{ computedBtnProviderText }}
                    </button>

                    <button
                        v-if="isAppPassword && linkClicked"
                        class="btn btn-blue login__steps__btn-provider login__steps__btn-provider-clicked mt__8 blue-desktop-hover"
                        @click="goStep('2FA')"
                    >{{ $t('web_login_google_app_password_app_password_not_available') }}
                    </button>

                </div>

                <div v-show="isLogin" class="login__steps__container">

                    <login-v2 :provider="provider" @showImapStep="goStep('imap')"
                              @showAppPassStep="goStep('appPass')"></login-v2>

                </div>

                <div v-if="showFooter" class="login__footer login__left">

                    <div v-if="!isDesktop" class="login__footer__container">

                        <button class="login__footer__btn" @click="TagClick('start');nextStep()">
                            {{ computedBtnFooterText }}
                        </button>

                        <div v-if="isIntro" class="login__footer__row mt__8">

                            <img class="login__footer__ico" src="/img/icons/clock-grey.svg">

                            <p class="login__footer__text">{{ $t('web_login_google_welcome_timing') }}</p>

                        </div>

                    </div>
                    <template v-else>

                        <div class="login__footer__desktop">

                            <template v-if="isLogin">

                                <p class="login__footer__desktop__secu">{{ $t('web_login_google_connect_safety') }}</p>

                            </template>

                            <template v-else>

                                <button class="login__footer__btn login__footer__desktop__btn-left blue-desktop-hover"
                                        @click="TagClick('back');previousStep()">{{
                                        $t('web_login_google_imap_cta_back')
                                    }}
                                </button>

                                <button :class="{ 'login__footer__desktop__btn-right-active': linkClicked }"
                                        class="login__footer__btn login__footer__desktop__btn-right"
                                        @click="TagClick('next_step');tutoNextStep()"
                                        @mouseleave="leaveTipBtn"
                                        @mouseover="overTipBtn">
                                    <div v-if="showTip" class="login__footer__btn-tips">
                                        <div class="black-arrow"></div>
                                        <span class="black-arrow-text">{{
                                                $t('web_login_google_imap_error_pending')
                                            }}</span>
                                    </div>
                                    {{ $t('web_login_google_imap_cta_next_step') }}
                                </button>

                            </template>

                        </div>

                    </template>

                </div>

            </div>

            <div v-if="isDesktop" class="login__right">

                <transition name="modaliscomming">

                    <img v-show="showDesktopBloc" :src="desktopImg" class="login__right__bloc">

                </transition>

            </div>

        </div>

    </div>

</template>

<script>

import Vuex from 'vuex'

import Tag from '@/modules/tag'

import Markdown from '@/components/Markdown'
import LoginV2 from '@/components/loginFlow/LoginV2'

export default {

    name: 'login-provider-v2',

    components: {Markdown, LoginV2},

    computed: {
        ...Vuex.mapGetters(['fastPass', 'lang']),

        providerSteps: function () {
            return this.allProvidersSteps[this.provider]
        },

        actualStep: function () {
            return this.providerSteps[this.stepName]
        },

        computedBtnProviderText: function () {
            const str = this.actualStep.linkText
            return str ? this.$t(str) : ''
        },

        computedBtnFooterText: function () {
            return this.isTuto > 1 ? this.$t('web_login_google_welcome_CTA_start') : this.$t('web_login_google_imap_cta_next_step')
        },

        showFooter: function () {

            return this.isDesktop
                ? !this.isIntro
                : this.isIntro || (this.isTuto && this.linkClicked)
        },

        showDesktopBloc: function () {
            return this.desktopImg && this.desktopImg.length && this.desktopText.length && this.isTuto
        },

        isIntro: function () {
            return this.stepName === 'intro'
        },

        isTuto: function () {
            return this.stepName === 'appPass' || this.stepName === 'imap' || this.stepName === '2FA'
        },

        isAppPassword: function () {
            return this.stepName === 'appPass'
        },

        isLogin: function () {
            return this.stepName === 'login'
        },

        showTip: function () {
            return this.tipBtnFocus && !this.linkClicked
        }
    },

    data() {
        return {
            provider: '',
            stepName: '',
            linkClicked: false,
            allProvidersSteps: {
                google: {
                    appPass: {
                        link: 'https://myaccount.google.com/apppasswords?rapt=AEjHL4MyVrSrHEfjlximg9HCIeU4nPSc2Y2szCH30ezhUGvuLCuuXa6pySzlj4L3TZ-i5KtvUe6pEOd7wOz65Yv_w3T172lwgA',
                        linkText: 'web_login_google_imap_cta_continue',
                        img: '/img/login/password.svg',
                        title: 'web_login_google_app_password_title',
                        subtitle: 'web_login_google_app_password_subtitle',
                        steps: [
                            {text: 'web_login_google_app_password_step_1', active: false, type: '2-fa-1'},
                            {text: 'web_login_google_app_password_step_2', active: false, type: '2-fa-2'},
                            {text: 'web_login_google_app_password_step_3', active: false, type: '2-fa-3'}
                        ]
                    },
                    imap: {
                        img: '/img/login/imap.svg',
                        title: 'web_login_google_imap_title',
                        subtitle: 'web_login_google_imap_subtitle',
                        link: 'https://mail.google.com/mail/u/1/#settings/fwdandpop',
                        linkText: 'web_login_google_imap_cta_continue',
                        steps: [
                            {text: 'web_login_google_imap_step_1', active: false}
                        ]
                    },
                    '2FA': {
                        img: '/img/login/2-fa.svg',
                        title: 'web_login_google_2FA_title',
                        subtitle: 'web_login_google_2FA_description',
                        link: 'https://myaccount.google.com/u/1/signinoptions/two-step-verification?rapt=AEjHL4P60I06wZZeVdk62ynLMLTj0htLdZ_R9MYqKVc-B6SH5MwTepBxw2w1cq2XRh3yuH5F5GBUdtMINKcWk999CdCYQVpc-A',
                        linkText: 'web_login_google_imap_cta_continue',
                        steps: []
                    }
                }
            },
            desktopImg: '',
            desktopTextIndex: '1',
            desktopText: '',
            tipBtnFocus: false,
            screenWidth: 0,
            invalidGrant: false
        }
    },

    created() {
        const splitRoute = this.$route.path.split('/')
        this.provider = splitRoute[splitRoute.length - 1]
        this.invalidGrant = this.$route.query.ig === 'true'
        window.addEventListener('resize', this.resizeHandler)
        this.resizeHandler()
    },

    mounted() {

        this.fastPass
            ? this.goStep('login')
            : this.goStep('intro')
    },

    methods: {

        goStep(stepName) {
            // intro
            // appPass
            // imap
            // 2FA
            // login
            this.stepName = stepName
            this.linkClicked = false
            this.desktopImg = this.isTuto && this.actualStep.steps[0] && `/img/login/2-fa/2-fa-1-${this.lang}.svg`
            this.desktopText = this.isTuto && this.actualStep.steps[0] && this.actualStep.steps[0].text || ''
            switch (stepName) {
                case 'intro':
                    Tag.pageViewAll(this, 'web_login_google_welcome')
                    break
                case 'appPass':
                    Tag.pageViewAll(this, 'web_login_google_app_password')
                    break
                case 'imap':
                    Tag.pageViewAll(this, 'web_login_google_imap')
                    break
                case '2FA':
                    Tag.pageViewAll(this, 'web_login_google_2FA')
                    break
                case 'login':
                    Tag.pageViewAll(this, 'web_login_google_connect')
                    break
            }
        },

        previousStep() {
            if (this.stepName === 'appPass') {
                this.goStep('intro')
            } else if (this.stepName === '2FA') {
                this.goStep('appPass')
            } else {
                this.goStep('login')
            }
        },

        nextStep() {

            this.stepName === '2FA' || this.stepName === 'intro'
                ? this.goStep('appPass')
                : this.goStep('login')

            if (this.isTuto && this.isDesktop) {
                this.allProvidersSteps[this.provider][this.stepName].steps.forEach(element => element.active = false)
                this.allProvidersSteps[this.provider][this.stepName].steps[0].active = true
            }
        },

        tutoNextStep() {
            if (this.linkClicked) {
                this.nextStep()
            } else {
                Tag.infoAll(this, `web_login_google_${this.stepName}_next_error`)
            }
        },

        openProviderSettings() {
            window.open(this.actualStep.link, '_blank', 'rel="noopener,noreferrer,nofollow"')
            this.linkClicked = true
        },

        tips() {
            this.goStep('login')
        },

        overTipBtn() {
            this.tipBtnFocus = true
        },

        leaveTipBtn() {
            this.tipBtnFocus = false
        },

        mouseOver(step, index) {
            if (this.isDesktop) {
                this.desktopImg = `/img/login/2-fa/${step.type}-${this.lang}.svg`
                this.desktopText = step.text
                this.desktopTextIndex = index
                this.allProvidersSteps[this.provider][this.stepName].steps.forEach(element => element.active = false)
                this.allProvidersSteps[this.provider][this.stepName].steps[index - 1].active = true
            }
        },

        TagClick(name) {
            Tag.clickAll(this, name, this.provider)
        },

        goLanding() {
            this.$router.push({path: '/'})
        },

        getStepText(languageKey) {

            return languageKey === 'web_login_google_imap_step_1' && !this.isDesktop
                ? this.$t('login_provider_tuto_web_description_1_google_webmobile')
                : this.$t(languageKey)
        },

        resizeHandler() {
            this.screenWidth = window.screen.width
        }
    },

    destroyed() {
        window.removeEventListener('resize', this.resizeHandler)
    }
}
</script>

<style lang="scss" scoped>

.login {

    background-color: $white;
    color: $charcoal;
    text-align: start;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex: 1;

    &__title {
        font-size: 34px;
        font-weight: 600;
        line-height: 1.18;
    }

    &__subtitle {
        font-size: 22px;
        font-weight: 600;
        line-height: 1.09;
    }

    &__text {
        font-size: 17px;
        line-height: 1.41;
    }

    &__text-btn {
        font-size: 15px;
        font-weight: 500;
        line-height: 1.33;
    }

    &__text-btn-dashed {
        color: $moon;
    }

    &__header {
        width: 100%;
        height: 56px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        box-shadow: 0 1px 0 0 rgba(17, 17, 26, 0.1);
        @media screen and (min-width: $above-book-length) {
            padding: 0 32px;
        }

        &__between {
            justify-content: space-between;
        }

        &__img {
            cursor: pointer;
            height: 32px;
            object-fit: contain;
        }

        &__text {
            font-size: 16px;
            font-weight: 600;
            line-height: 1;
            display: flex;
            flex-direction: row;
        }

        &__btn {
            margin: 0 4px;
            color: $aquamarine;
            cursor: pointer;
            text-decoration: underline;
            margin-left: 2px;
        }
    }

    &__steps {
        &__container {
            padding: 32px 20px 148px;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            max-width: 480px;
            text-align: start;
            @media screen and (min-width: $above-book-length) {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                flex-grow: 1;
            }
        }

        &__container-intro {
            @media screen and (min-width: $above-book-length) {
                padding: 32px 20px;
                align-items: center;
            }
        }

        &__bloc {
            @media screen and (min-width: $above-book-length) {
                max-width: 416px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
            }
        }

        &__btn {
            padding: 16px 24px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            border-radius: 20px;
            background-color: $white;
            border: solid 4px $timberwolf;
            width: 100%;
            text-align: start;
        }

        &__btn-active {
            transition: 0.3s;
            @media screen and (min-width: $above-book-length) {
                border-color: $aquamarine;
            }
        }

        &__btn-dashed {
            padding: 16px 24px;
            border-radius: 20px;
            border: solid 4px $timberwolf;
        }

        &__number {
            font-size: 15px;
            font-weight: 600;
            line-height: 1.07;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            max-width: 32px;
            height: 32px;
            border-radius: 100%;
            border: solid 4px $timberwolf;
            margin-right: 16px;

            &:lang(ar-sa) {
                margin-right: unset;
                margin-left: 16px;
            }
        }

        &__number-dashed {
            color: $moon;
            border: dashed 4px $timberwolf;
        }

        &__img {
            width: 80px;
            object-fit: contain;
        }

        &__btn-provider {
            height: 64px;
            @media screen and (min-width: $above-book-length) {
                width: min-content;
                white-space: nowrap;
                padding: 24px 32px;
            }
        }

        &__btn-provider-clicked {
            background-color: white;
            border: solid 4px $timberwolf;
            color: $charcoal;
        }
    }

    &__footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 16px 20px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: $white;
        box-shadow: 0 0 0 1px rgba(17, 17, 26, 0.1);

        &:lang(ar-sa) {
            left: unset;
        }

        &__container {
            max-width: 480px;
            width: 100%;
        }

        &__row {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width: 100%;
            @media screen and (min-width: $above-book-length) {
                justify-content: flex-start;
            }
        }

        &__ico {
            width: 16px;
            object-fit: contain;
            margin-right: 4px;

            &:lang(ar-sa) {
                margin-right: 0;
                margin-left: 4px;
            }
        }

        &__btn {
            cursor: pointer;
            width: 100%;
            padding: 24px;
            border-radius: 64px;
            background-color: $forest;
            font-size: 16px;
            font-weight: 600;
            line-height: 1;
            color: $white;
            @media screen and (min-width: $above-book-length) {
                max-width: 253px;
            }
        }

        &__btn-tips {
            width: 200px;
            position: absolute;
            background-color: black;
            font-size: 14px;
            font-weight: 500;
            color: $white;
            border-radius: 2px;
            padding: 4px 8px;
            top: -52px;
            left: 0;
            white-space: break-spaces;
            display: flex;
            justify-content: center;
        }

        &__text {
            font-size: 12px;
            font-weight: 600;
            line-height: 1.33;
            color: $moon;
        }

        &__desktop {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 12px 32px;
            width: 100%;

            &__btn-left {
                background-color: $white;
                padding: 20px 32px;
                border-radius: 64px;
                border: solid 4px $timberwolf;
                color: $charcoal;
                width: min-content;
                white-space: nowrap;
            }

            &__btn-right {
                position: relative;
                padding: 20px 32px;
                border-radius: 64px;
                width: min-content;
                background-color: $timberwolf;
                color: $stone;
                white-space: nowrap;
                cursor: not-allowed;
            }

            &__btn-right-active {
                color: $white;
                background-color: $forest;
                cursor: pointer;
            }

            &__secu {
                font-size: 12px;
                line-height: 1.33;
                text-align: center;
                color: $moon;
            }
        }
    }

    &__left {
        width: 100%;
        align-items: center;
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $above-book-length) {
            display: flex;
            flex-direction: column;
            min-width: 480px;
            max-width: 40%;
            width: 100%;
            align-items: center;
        }
    }

    &__right {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: url('/img/login/desktop-solid.jpg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        padding: 8px;

        &:lang(ar-sa) {
            transform: scaleX(-1);
        }

        &__bloc {
            width: 100%;
            max-width: 524px;
            border-radius: 20px;
            overflow: hidden;
            &:lang(ar-sa) {
                transform: scaleX(-1);
            }
        }

        &__text-container {
            padding: 16px 24px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            box-shadow: 0 -1px 0 0 rgba(17, 17, 26, 0.1);
        }
    }
}

.black-arrow {
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: black;
    transform: rotate(45deg);
    bottom: -5px;
}

.black-arrow-text {
    z-index: 1;
}

.blue-desktop-hover:hover {
    transition: 0.3s;
    @media screen and (min-width: $above-book-length) {
        border-color: $aquamarine;
    }
}

/*animation*/


.modaliscomming-enter-active {
    transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.modaliscomming-leave-active {
    transition: 0.2s cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.modaliscomming-enter {
    transform: translate(0, 20%);
    opacity: 0;
}

.modaliscomming-leave-to {
    opacity: 0;
}

</style>
